import * as React from "react";
import IHabitStaticData from "../../../models/staticData/IHabitStaticData";
import Questionnaire from "../../common/Questionnaire";
import TemplatedList from "../../TemplatedList";
import ModelFactory from "../../../models/ModelFactory";
import {default as CustomHeader, ICustomHeaderInfo} from "../../utils/CustomHeader";
import IPatientWorkoutPreference from "../../../models/patients/IPatientWorkoutPreference";
import ToggleButtonList from "../../ToggleButtonList";
import {AppConstants, QuestionType} from "../../../utils/AppConstants";
import IDishCatalogueResponse from "../../../models/maverick/IDishCatalogueResponse";

interface WorkoutHabitProps {
    preferenceType: string;
    booleanToggleHandler: (selectedBtn: any, key: string) => void;
    updatedWorkoutPreferences: {item: IPatientWorkoutPreference}[];
    updateWorkoutPreferences: (preferences: IPatientWorkoutPreference[], type: string) => void;
    selectableToggleHandler: (selectedBtn: any, key: string) => void;
    keyName: string;
    question: string;
    fetchFitnessActivities?: (input: string) => Promise<any>;
}
interface WorkoutHabitState {
    regular: boolean;
}
export class WorkoutHabit extends React.Component<WorkoutHabitProps, WorkoutHabitState> {
    constructor(props: WorkoutHabitProps) {
        super(props);
        let regular = props.updatedWorkoutPreferences.length ? true : false;
        this.state = {
            regular
        }
    }
    onWorkoutRemove = (index: number) => {
        let currUpdatedAllergies = Object.assign([], this.props.updatedWorkoutPreferences);
        currUpdatedAllergies.splice(index, 1);
        this.props.updateWorkoutPreferences(currUpdatedAllergies, this.props.preferenceType);
    }

    onWorkoutChange = (updatedPreference: IPatientWorkoutPreference, index: number) => {
        let currUpdatedPreferences = Object.assign([], this.props.updatedWorkoutPreferences);
        currUpdatedPreferences[index] = updatedPreference;
        this.props.updateWorkoutPreferences(currUpdatedPreferences, this.props.preferenceType);
    }
    booleanToggleHandler = (value: any) => {
        if (!value) {
            this.props.updateWorkoutPreferences([], this.props.preferenceType)
        }
        this.setState({
            regular: value
        })
    }
    render() {
        return <div>
            <div className="consumption-ques-container">
                <div className="question-text in-blk">{this.props.question}</div>
                <div className="ques-answer in-blk">
                    <ToggleButtonList listItems={AppConstants.YesNoToggleList} type={QuestionType.BOOLEAN_TOGGLE} selectedItems={[this.state.regular]}
                                      onSelectionChange={this.booleanToggleHandler} keyName={this.props.keyName}/>
                </div>
            </div>
            {
                this.state.regular &&
                <div className={"preferences-list-container"}>
                    <CustomHeader headerInfos={HabitsEditorHeaderInfos} rootCls={"patient-workout-preference"}/>
                    <TemplatedList templateName={"workoutPreference"} commonProps={{fetchFitnessActivities: this.props.fetchFitnessActivities}}
                                   defaultItem={{item: ModelFactory.createNewWorkoutPreferenceItem()}}
                                   listItems={this.props.updatedWorkoutPreferences}
                                   onItemRemove={this.onWorkoutRemove}
                                   onItemChange={this.onWorkoutChange}/>
                </div>
            }
        </div>
    }
}

export interface PatientLifestyleHabitsEditorProps {
    [index: string]: any;
    staticPatientHabits: IHabitStaticData;
    consumptionFrequency: any;
    meditationPreference: {item: IPatientWorkoutPreference}[];
    workoutPreference: {item: IPatientWorkoutPreference}[];
    updateHandler: (data: any, key: string) => void;
    fetchFitnessActivities?: (input: string) => Promise<any>;
    fetchMindfulnessActivities?: (input: string) => Promise<any>;
    fetchStaticDishes: (input: string) => Promise<IDishCatalogueResponse | IDishCatalogueResponse[]>;
    showHabitsOnly?: boolean;
}
interface PatientLifestyleHabitsEditorStates {
    foodName: string;
    foodDislikeName: string;
}

let HabitsEditorHeaderInfos: ICustomHeaderInfo[] = [
    {label: "type", display: "TYPE"},
    {label: "timeOfDay", display: "TIME OF DAY"},
    {label: "frequency", display: "FREQUENCY"},
    {label: "duration", display: "DURATION"},
    {label: "comments", display: "COMMENTS"}
];

export default class PatientLifestyleHabitsEditor extends React.Component<PatientLifestyleHabitsEditorProps, PatientLifestyleHabitsEditorStates> {
    constructor(props: PatientLifestyleHabitsEditorProps) {
        super(props);
        this.state = {foodName: "", foodDislikeName: ""};
    }
    updateConsumptionFreqHandler = (value: any, key: string) => {
        let updatedConsumptionFreq = {...this.props.consumptionFrequency};
        updatedConsumptionFreq[key] = value;
        this.props.updateHandler(updatedConsumptionFreq, "consumptionFreq");
    }
    booleanToggleHandler = (selectedBtn: any, key: string) => {
        let updatedInfo = {...this.props[key]};
        updatedInfo.regular = selectedBtn;
        if (!selectedBtn) {
            updatedInfo.weeklySchedule = [];
        }
        this.props.updateHandler(updatedInfo, key);
    }
    selectableToggleHandler = (selectedBtn: any, key: string) => {
        let updatedInfo = {...this.props[key]};
        updatedInfo.weeklySchedule = selectedBtn;
        this.props.updateHandler(updatedInfo, key);
    }
    updateWorkoutPreferences = (workoutPreferences: IPatientWorkoutPreference[], type: string) => {
        this.props.updateHandler(workoutPreferences, type);
    }
    render() {
        let {staticPatientHabits, showHabitsOnly} = this.props;
        let {consumptionFrequency, workoutPreference, meditationPreference, foodDislikes} = this.props;
        let showConsumptionFrq = staticPatientHabits && staticPatientHabits.consumptionFrequency;
        return <div className="patient-habit-editor-container">
            {showConsumptionFrq && <div>
                <div className="section-header">Consumption frequency</div>
                <div className="consumption-freq-container">
                    {staticPatientHabits.consumptionFrequency.questionnaire.map((question, index) => {
                        let answer = consumptionFrequency[question.key];
                        return <div key={index} className="consumption-ques-container">
                            <Questionnaire question={question} answer={answer} updateHandler={this.updateConsumptionFreqHandler} hideComment={false} supportDecimal={true}/>
                        </div>
                    })}
                </div>
            </div>}
            {!showHabitsOnly && <div>
                <div className="section-header">Workout preferences</div>
                <div className="workout-pref-container">
                    <WorkoutHabit booleanToggleHandler={this.booleanToggleHandler} updatedWorkoutPreferences={workoutPreference}
                                  preferenceType={"workoutPreference"} updateWorkoutPreferences={this.updateWorkoutPreferences}
                                  fetchFitnessActivities={this.props.fetchFitnessActivities}
                                  selectableToggleHandler={this.selectableToggleHandler} keyName="workoutPreference" question={"Do you workout regularly?"}/>
                </div>
            </div>}
            {!showHabitsOnly && <div>
                <div className="section-header">Meditation preferences</div>
                <div className="meditation-pref-container">
                    <WorkoutHabit booleanToggleHandler={this.booleanToggleHandler} updatedWorkoutPreferences={meditationPreference}
                                  preferenceType={"meditationPreference"} updateWorkoutPreferences={this.updateWorkoutPreferences}
                                  fetchFitnessActivities={this.props.fetchMindfulnessActivities}
                                  selectableToggleHandler={this.selectableToggleHandler} keyName="meditationPreference" question={"Do you meditate regularly?"}/>
                </div>
            </div>}
        </div>
    }
}